// extracted by mini-css-extract-plugin
export default {"controls":"TableRowControls_controls__vFYR9"};